import React, { Component, Fragment } from 'react'
import axios from 'axios'
import {
  changePhase,
  changeStartDate,
  changeTargetEndDate,
  changeStatus,
  changeRegulatoryRelated,
  changeBudgetedHours,
  changeTitle,
  changeDescription,
  changeShortId,
  changeClient,
  changeNumber,
  changeProposals,
  changeProjectLeads,
  changeAnalysts,
  changeDirectory,
  changeRDUID,
  resetPhase,
  submitProject,
} from '../../reducers/manageProjectCreation'
// import { handleErrorFetchingData } from '../../../../functions/errorHandling'

import { connect } from 'react-redux'
import { Modal, Button, FormGroup, FormControl, Alert } from 'react-bootstrap'
import DatePicker from 'react-16-bootstrap-date-picker'
import { Typeahead } from 'react-bootstrap-typeahead'

import getServerURL from '../../../../functions/getServerURL'

class PhaseOne extends Component {

  state = {
    showAlert: false,
    numberInUseAlert: '',
    numberInUse: null,
    proposalOptions: [],
  }

  // componentDidMount() {
  //   if (this.props.client) {
  //     let clientId = this.props.client.split('client/')[1]
  //     clientId = clientId.slice(0, clientId.length - 1)
  //     this.getClientProposals(clientId)
  //   }
  // }


  handleSubmit = () => {
    if(!this.props.rduid | !this.props.title) {
      this.setState({ showAlert: true })
      return 
    }
    this.props.submitProject(this.props)
  }


  generateFormattedDate = (date) => {
    const year = new Date(date).getFullYear()
    const month = new Date(date).getMonth()
    const day = new Date(date).getDate()
    return new Date(year, month, day).toISOString()
  }


  updateStartDate = (date) => {
    let startDate = null
    if (date) {
      startDate = this.generateFormattedDate(date)
    }
    return this.props.changeStartDate(startDate)
  }

  updateTargetEndDate = (date) => {
    let targetEndDate = null
    if (date) {
      targetEndDate = this.generateFormattedDate(date)
    }
    return this.props.changeTargetEndDate(targetEndDate)
  }

  getValidationState = () => {
    if (this.state.numberInUse === true) {
      return "error"
    }
    if (this.state.numberInUse === false) {
      return "success"
    }
    if (this.state.numberInUse === "warning") {
      return "warning"
    }
  }


  // handleNextPhase = () => {
  //   const { title, client, proposals } = this.props.phaseOne
  //
  //   if (!title.length || !client.length || !proposals.length) {
  //     this.setState({showAlert: true}, () => {
  //       setTimeout(() => this.setState({ showAlert: false }), 5000)
  //     })
  //   } else {
  //     this.props.changePhase(2)
  //   }
  // }

  handleSelectClient = (clientUrl) => {
    const { clients } = this.props

    if (clientUrl) {
      let client = clients.find(client => client.url === clientUrl)

      this.props.changeShortId(client.short_code)
      this.props.changeClient(clientUrl)
      // this.props.changeProposals([])
      // this.getClientProposals(client.id)
    } else {
      this.props.resetPhase()
    }
  }

  // proposalsLabelKey = (proposal) => {
  //   const { client } = proposal
  //   return `${client.name}-${client.short_code} - ${proposal.number} - ${proposal.title}`
  // }

  // getClientProposals = (client) => {
  //   this.setState({ fetchingProposals: true, proposalOptions: [] })
  //
  //   axios({
  //     method:"GET",
  //     url:`${getServerURL()}client-proposals/`,
  //     headers:{"Authorization": "Bearer " + localStorage.getItem("token")},
  //     params: {
  //       client,
  //     }
  //   })
  //   .then(response => {
  //     if (response.data.length) {
  //       this.props.changeProposals([response.data[0]])
  //     }
  //     this.setState({ fetchingProposals: false, proposalOptions: response.data })
  //   })
  //   .catch(error => {
  //     // const message = "There was an error retrieving the client's proposals from the server."
  //     const message = "There was an error generating the form."
  //     handleErrorFetchingData(error, message)
  //     this.setState({ fetchingProposals: false, proposalOptions: [] })
  //   })
  // }

  verifyProjectNumber = () => {
    let { client, number } = this.props

    client = client.split('client/')[1].slice(0, -1)

    if (!client || number === '') {
      this.setState({ numberInUse: null })
      return
    }

    axios({
      method:"GET",
      url:`${getServerURL()}verify-project-number/`,
      headers:{"Authorization": "Bearer " + localStorage.getItem("token")},
      params: {
        client,
        number
      }
    })
    .then(response => {
      this.setState({ numberInUseAlert: "", numberInUse: false })
    })
    .catch(error => {
      if (error.response && error.response.status && error.response.status === 409) {
        const numberInUseAlert = error.response.data.detail
        this.props.changeNumber("")
        this.setState({ numberInUseAlert, numberInUse: true })
      }
    })
  }

  _renderMenuItemChildren = (option, props, index) => {
    // THIS METHOD ENABLES CUSTOM HIGHLIGHT FIELDS ON CLIENT CONTACT SELECTION
    return [
      <div key="name" search={props.text}>
        <strong>{option.first_name} {option.last_name}</strong>
      </div>,
      <div key="population">
        <small>
          Email: {option.email ? option.email : "N/A"}
        </small>
      </div>,
    ]
  }

  render () {

    const {
      title,
      number,
      // shortId,
      description,
      client,
      // proposals,
      status,
      regulatoryRelated,
      budgetedHours,
      startDate,
      targetEndDate,
      projectLeads,
      analysts,
      directory,
      rduid,
      clients,
    } = this.props

    const users = this.props.users

    const clientOptions = clients.map(client => {
      if (client.managed_by_genesis) {
        return (
          <option key={ client.url } value={ client.url }>
            { client.name } { client.short_code }
          </option>
        )
      } else {
        return null
      }
    })

    return (
      <div id="PhaseOne">
        <Modal.Body>
          <div>
            <h5>
              Client: <span className="required">*</span>
            </h5>
            <FormControl
              componentClass="select"
              placeholder="select"
              value={ client }
              onChange={ (e) => this.handleSelectClient(e.target.value) }
              >
              <option value="">Select a client</option>
              {clientOptions}
            </FormControl>
          </div>

          {/*{client && !this.state.fetchingProposals ?*/}
          {/*  <div>*/}
          {/*    <h5>*/}
          {/*      Proposal(s) <span className="required">*</span>*/}
          {/*    </h5>*/}
          {/*    <Typeahead*/}
          {/*      id="ProjectCreationProposalsFilterTypeahead"*/}
          {/*      clearButton*/}
          {/*      labelKey={this.proposalsLabelKey}*/}
          {/*      multiple*/}
          {/*      selected={proposals}*/}
          {/*      options={this.state.proposalOptions}*/}
          {/*      placeholder="Proposal(s)"*/}
          {/*      onChange={this.props.changeProposals}*/}
          {/*      />*/}
          {/*  </div>*/}
          {/*  :*/}
          {/*  null*/}
          {/*}*/}

          {/*{client && this.state.fetchingProposals ?*/}
          {/*  <div id="not-found">*/}
          {/*    <center>*/}
          {/*      <img alt="loader" src={require("../../../../static/images/spinner.gif")} />*/}
          {/*      <br/>*/}
          {/*      Generating form...*/}
          {/*    </center>*/}
          {/*  </div>*/}
          {/*  :*/}
          {/*  null*/}
          {/*}*/}

          {/*{client && proposals && proposals.length && !this.state.fetchingProposals ?*/}
          {client ?
            <Fragment>
              <div>
                <h5>Project Title: <span className="required">*</span></h5>
                <FormControl
                  id="formControlProjectTitle"
                  value={title}
                  onChange={(e) => this.props.changeTitle(e.target.value)}
                  placeholder="Enter a title"
                />
              </div>

              <div>
                <h5>Revenue Dashboard Unique Identifier (RD_UID): <span className="required">*</span></h5>
                <FormControl
                  id="formControlRDUID"
                  value={rduid}
                  onChange={(e) => {
                    const containsSpecialChars = /[^a-zA-Z0-9]/.test(e.target.value)
                    if (!containsSpecialChars) this.props.changeRDUID(e.target.value.toUpperCase())
                  }}
                  placeholder="Enter a RDUID"
                />
              </div>

              <div>
                <h5>Number (this will be automatically generated if left blank):</h5>
                <FormGroup validationState={this.getValidationState()}>
                  <FormControl
                    id="projectNumberInput"
                    value={number}
                    type="number"
                    onFocus={() => this.setState({ numberInUseAlert: '', numberInUse: 'warning' })}
                    onChange={(e) => this.props.changeNumber(e.target.value)}
                    onBlur={this.verifyProjectNumber}
                    placeholder="Enter up to 4 digits"
                  />
                  <FormControl.Feedback />
                </FormGroup>
                {this.state.numberInUseAlert ?
                  <p className="required">
                    {this.state.numberInUseAlert}
                  </p>
                  :
                  null
                }
              </div>

              <div>
                <h5>Description:</h5>
                <FormControl
                  style={{resize:"none"}}
                  id="formControlDescription"
                  componentClass="textarea"
                  value={description}
                  onChange={(e) => this.props.changeDescription(e.target.value)}
                  placeholder="Enter a description"
                />
              </div>

              <div>
                <h5>Status:</h5>
                <FormControl
                  componentClass="select"
                  placeholder="select"
                  value={status}
                  onChange={(e) => this.props.changeStatus(e.target.value)}
                  >
                  <option value="Active">Active</option>
                  <option value="On Hold">On Hold</option>
                  <option value="Not Started">Not Started</option>
                  <option value="Completed">Completed</option>
                </FormControl>
              </div>

              <div>
                <h5>Regulatory Related:</h5>
                <FormControl
                  componentClass="select"
                  placeholder="select"
                  value={regulatoryRelated}
                  onChange={(e) => this.props.changeRegulatoryRelated(e.target.value)}
                  >
                  <option value="No">No</option>
                  <option value="Yes">Yes</option>
                </FormControl>
              </div>

              <div>
                <h5>Budgeted Hours:</h5>
                <FormControl
                    id="budgetedHoursInput"
                    value={budgetedHours}
                    type="number"
                    min={0}
                    step={0.25}
                    onChange={(e) => this.props.changeBudgetedHours(e.target.value)}
                    placeholder="Enter budgeted hours"
                  />
              </div>

              <div>
            <h5>Project Lead(s):</h5>
            <Typeahead
              id="InternalStakeholders/ProjectLeadsTypeahead"
              multiple
              renderMenuItemChildren={this._renderMenuItemChildren}
              labelKey={(option) => `${option.first_name} ${option.last_name}`}
              options={users}
              selected={projectLeads}
              onChange={(value) => this.props.changeProjectLeads(value)}
              placeholder="Select project lead(s)"
              />
          </div>

          <div>
            <h5>Analyst(s):</h5>
            <Typeahead
              id="AnalystsTypeahead"
              multiple
              renderMenuItemChildren={this._renderMenuItemChildren}
              labelKey={(option) => `${option.first_name} ${option.last_name}`}
              options={users}
              selected={analysts}
              onChange={(value) => this.props.changeAnalysts(value)}
              placeholder="Select an analyst"
              />
          </div>

              <div>
                <h5>Start Date:</h5>
                <DatePicker
                  calendarPlacement="top"
                  value={startDate ? this.generateFormattedDate(startDate) : null }
                  dateFormat="MM-DD-YYYY"
                  weekStartsOn={1}
                  onChange={(value, formattedValue) => this.updateStartDate(value)}
                  />
              </div>

              <div>
                <h5>Target End Date:</h5>
                <DatePicker
                  calendarPlacement="top"
                  value={targetEndDate ? this.generateFormattedDate(targetEndDate) : null }
                  dateFormat="MM-DD-YYYY"
                  weekStartsOn={1}
                  onChange={(value, formattedValue) => this.updateTargetEndDate(value)}
                />
              </div>

              <div>
                <h5>Directory:</h5>
                <FormControl
                  id="formControlDirectory"
                  value={directory}
                  onChange={(e) => this.props.changeDirectory(e.target.value)}
                  placeholder="Enter a directory"
                />
              </div>

            </Fragment>
            :
            null
          }
          {this.state.showAlert ?
            <div>
              <br/>
              <Alert
                bsStyle="danger"
                onDismiss={() => this.setState({showAlert: false})}
              >
                <h4>Please fill out all required fields</h4>
                <p>
                  Required fields are marked with <span className="required">*</span>
                </p>
              </Alert>
            </div>
            :
            null
          }
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.props.handleCancel}>
            Cancel
          </Button>

          <Button bsStyle="primary" onClick={this.handleSubmit}>
            Submit
          </Button>
          {/* <Button bsStyle="primary" onClick={this.handleNextPhase}>
            Next
          </Button> */}
        </Modal.Footer>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    users: state.manageLogin.users,
    currentUser: state.manageLogin.user,
    clients: state.manageLogin.clients,
    // proposalOptions: state.manageProposals.proposals,

    title: state.manageProjectCreation.title,
    number: state.manageProjectCreation.number,
    shortId: state.manageProjectCreation.shortId,
    description: state.manageProjectCreation.description,
    client: state.manageProjectCreation.client,
    proposals: state.manageProjectCreation.proposals,
    status: state.manageProjectCreation.status,
    regulatoryRelated: state.manageProjectCreation.regulatoryRelated,
    budgetedHours: state.manageProjectCreation.budgetedHours,
    startDate: state.manageProjectCreation.startDate,
    targetEndDate: state.manageProjectCreation.targetEndDate,
    projectLeads: state.manageProjectCreation.projectLeads,
    analysts: state.manageProjectCreation.analysts,
    directory: state.manageProjectCreation.directory,
    rduid: state.manageProjectCreation.rduid,
  }
}

export default connect(mapStateToProps, {
  changePhase,
  changeStartDate,
  changeBudgetedHours,
  changeTargetEndDate,
  changeStatus,
  changeRegulatoryRelated,
  changeTitle,
  changeDescription,
  changeShortId,
  changeClient,
  changeNumber,
  changeProposals,
  changeProjectLeads,
  changeAnalysts,
  changeDirectory,
  changeRDUID,
  resetPhase,
  submitProject,
})(PhaseOne);



// WEBPACK FOOTER //
// ./src/routes/projects/components/project_creation/PhaseOne.js